import { handleActions, handleAction } from "redux-actions";
import {
  AUTH,
  SET_PROFILE,
  SET_CURRENT_ROUTE,
  LOGOUT,
  SHOW_NOTIFICATION,
  CLOSE_NOTIFICATION,
  SET_SIDE_MENU_STATE,
  OPEN_USERS_FORM,
  CLOSE_USERS_FORM,
  EDIT_SELECTED_USER,
  USERS_FORM_TOOGLE_LOADING,
  SET_USER_LIST,
  ADD_NEW_USER,
  UPDATE_USER,
  DELETE_USER,
  OPEN_ALERT_FORM,
  CLOSE_ALERT_FORM,
  EDIT_SELECTED_ALERT,
  ALERT_FORM_TOOGLE_LOADING,
  SET_ALERT_LIST,
  ADD_NEW_ALERT,
  UPDATE_ALERT,
  DELETE_ALERT,
  THEME,
  ADD_NEW_APPLICATION,
  SET_APPLICATION_LIST,
  UPDATE_APPLICATION,
  DELETE_APPLICATION,
  OPEN_APPLICATION_FORM,
  CLOSE_APPLICATION_FORM,
  EDIT_SELECTED_APPLICATION,
  APPLICATION_FORM_TOOGLE_LOADING,
  ADD_NEW_TICKET,
  SET_TICKET_LIST,
  UPDATE_TICKET,
  DELETE_TICKET,
  OPEN_TICKET_FORM,
  CLOSE_TICKET_FORM,
  EDIT_SELECTED_TICKET,
  TICKET_FORM_TOOGLE_LOADING,
  SET_IMPUTHOUR_LIST,
  ADD_NEW_IMPUTHOUR,
  UPDATE_IMPUTHOUR,
  DELETE_IMPUTHOUR,
  SET_PROJECTSNAV_LIST,
} from "./../../constants";

/* BASIC */
export const authorization = handleActions(
  {
    [AUTH]: (state, action) => action.payload,
    [LOGOUT]: () => ({ auth: false }),
  },
  null
);

/* PROFILE */
export const profile = handleActions(
  {
    [SET_PROFILE]: (state, action) => action.payload,
  },
  null
);

/* APP */
export const currentRoute = handleAction(
  SET_CURRENT_ROUTE,
  (state, action) => action.payload,
  {}
);

export const notifications = handleActions(
  {
    [SHOW_NOTIFICATION]: (state, action) => action.payload,
    [CLOSE_NOTIFICATION]: (state, action) => ({
      show: false,
      status: null,
      message: null,
    }),
  },
  { show: false, status: null, message: null }
);

/* APP */
export const app = handleActions(
  {
    [SET_SIDE_MENU_STATE]: (state, action) => {
      return { ...state, isCollapsedSideMenu: action.payload };
    },
  },
  { isCollapsedSideMenu: true }
);

export const currentTheme = handleAction(
  THEME,
  (state, action) => action.payload,
  true
);

export const users = handleActions(
  {
    [SET_USER_LIST]: (state, action) => action.payload,
    [ADD_NEW_USER]: (state, action) => {
      const newState = {
        ...state,
        [action.payload.value]: action.payload,
      };
      return newState;
    },
    [UPDATE_USER]: (state, action) => {
      const newState = {
        ...state,
        [action.payload.value]: action.payload,
      };
      return newState;
    },
    [DELETE_USER]: (state, action) => {
      action.payload.forEach((number) => {
        delete state[number];
      });
      return { ...state };
    },
  },
  null
);

export const usersForm = handleActions(
  {
    [OPEN_USERS_FORM]: (state) => ({
      show: !state.show,
      data: null,
      loading: false,
    }),
    [CLOSE_USERS_FORM]: () => ({ show: false, data: null, loading: false }),
    [EDIT_SELECTED_USER]: (s, action) => ({
      show: true,
      data: action.payload,
      loading: false,
    }),
    [USERS_FORM_TOOGLE_LOADING]: (state) => ({
      ...state,
      loading: !state.loading,
    }),
  },
  { show: false, data: null, loading: false }
);

export const alerts = handleActions(
  {
    [SET_ALERT_LIST]: (state, action) => action.payload,
    [ADD_NEW_ALERT]: (state, action) => {
      const newState = {
        ...state,
        [action.payload.value]: action.payload,
      };
      return newState;
    },
    [UPDATE_ALERT]: (state, action) => {
      const newState = {
        ...state,
        [action.payload.value]: action.payload,
      };
      return newState;
    },
    [DELETE_ALERT]: (state, action) => {
      action.payload.forEach((number) => {
        delete state[number];
      });
      return { ...state };
    },
  },
  null
);

export const alertsForm = handleActions(
  {
    [OPEN_ALERT_FORM]: (state) => ({
      show: !state.show,
      data: null,
      loading: false,
    }),
    [CLOSE_ALERT_FORM]: () => ({ show: false, data: null, loading: false }),
    [EDIT_SELECTED_ALERT]: (s, action) => ({
      show: true,
      data: action.payload,
      loading: false,
    }),
    [ALERT_FORM_TOOGLE_LOADING]: (state) => ({
      ...state,
      loading: !state.loading,
    }),
  },
  { show: false, data: null, loading: false }
);

// APPLICATIONS
export const applications = handleActions(
  {
    [SET_APPLICATION_LIST]: (state, action) => action.payload,
    [ADD_NEW_APPLICATION]: (state, action) => {
      const newState = {
        ...state,
        [action.payload.value]: action.payload,
      };
      return newState;
    },
    [UPDATE_APPLICATION]: (state, action) => {
      const newState = {
        ...state,
        [action.payload.value]: action.payload,
      };
      return newState;
    },
    [DELETE_APPLICATION]: (state, action) => {
      action.payload.forEach((number) => {
        delete state[number];
      });
      return { ...state };
    },
  },
  null
);

export const applicationsForm = handleActions(
  {
    [OPEN_APPLICATION_FORM]: (state) => ({
      show: !state.show,
      data: null,
      loading: false,
    }),
    [CLOSE_APPLICATION_FORM]: () => ({
      show: false,
      data: null,
      loading: false,
    }),
    [EDIT_SELECTED_APPLICATION]: (s, action) => ({
      show: true,
      data: action.payload,
      loading: false,
    }),
    [APPLICATION_FORM_TOOGLE_LOADING]: (state) => ({
      ...state,
      loading: !state.loading,
    }),
  },
  { show: false, data: null, loading: false }
);

// TICKETS
export const tickets = handleActions(
  {
    [SET_TICKET_LIST]: (state, action) => action.payload,
    [ADD_NEW_TICKET]: (state, action) => {
      const newState = {
        ...state,
        [action.payload.value]: action.payload,
      };
      return newState;
    },
    [UPDATE_TICKET]: (state, action) => {
      const newState = {
        ...state,
        [action.payload.value]: action.payload,
      };
      return newState;
    },
    [DELETE_TICKET]: (state, action) => {
      action.payload.forEach((number) => {
        delete state[number];
      });
      return { ...state };
    },
  },
  null
);

export const ticketsForm = handleActions(
  {
    [OPEN_TICKET_FORM]: (state) => ({
      show: !state.show,
      data: null,
      loading: false,
    }),
    [CLOSE_TICKET_FORM]: () => ({
      show: false,
      data: null,
      loading: false,
    }),
    [EDIT_SELECTED_TICKET]: (s, action) => ({
      show: true,
      data: action.payload,
      loading: false,
    }),
    [TICKET_FORM_TOOGLE_LOADING]: (state) => ({
      ...state,
      loading: !state.loading,
    }),
  },
  { show: false, data: null, loading: false }
);

// IMPUT HOURS
export const imputHours = handleActions(
  {
    [SET_IMPUTHOUR_LIST]: (state, action) => action.payload,
    [ADD_NEW_IMPUTHOUR]: (state, action) => {
      const newState = {
        ...state,
        [action.payload._id]: action.payload,
      };
      return newState;
    },
    [UPDATE_IMPUTHOUR]: (state, action) => {
      const newState = {
        ...state,
        [action.payload._id]: action.payload,
      };
      return newState;
    },
    [DELETE_IMPUTHOUR]: (state, action) => {
      const newState = { ...state };
      action.payload.forEach((id) => {
        delete newState[id];
      });
      return newState;
    },
  },
  {}
);

export const projectsnav = handleActions(
	{
		[SET_PROJECTSNAV_LIST]: (state, action) => action.payload,
	},
	null
);

// Función auxiliar para crear reducers CRUD
export const createCrudReducers = (prefix) => {
  const SET_LIST = `SET_${prefix}_LIST`;
  const ADD_NEW = `ADD_NEW_${prefix}`;
  const UPDATE = `UPDATE_${prefix}`;
  const DELETE = `DELETE_${prefix}`;
  const OPEN_FORM = `OPEN_${prefix}_FORM`;
  const CLOSE_FORM = `CLOSE_${prefix}_FORM`;
  const EDIT_SELECTED = `EDIT_SELECTED_${prefix}`;
  const FORM_TOGGLE_LOADING = `${prefix}_FORM_TOOGLE_LOADING`;

  const list = handleActions(
    {
      [SET_LIST]: (state, action) => action.payload,
      [ADD_NEW]: (state, action) => {
        const newState = {
          ...state,
          [action.payload.value || action.payload._id]: action.payload,
        };
        return newState;
      },
      [UPDATE]: (state, action) => {
        const newState = {
          ...state,
          [action.payload.value || action.payload._id]: action.payload,
        };
        return newState;
      },
      [DELETE]: (state, action) => {
        const newState = { ...state };
        action.payload.forEach((id) => {
          delete newState[id];
        });
        return newState;
      },
    },
    null
  );

  const form = handleActions(
    {
      [OPEN_FORM]: (state) => ({
        show: !state.show,
        data: null,
        loading: false,
      }),
      [CLOSE_FORM]: () => ({
        show: false,
        data: null,
        loading: false,
      }),
      [EDIT_SELECTED]: (s, action) => ({
        show: true,
        data: action.payload,
        loading: false,
      }),
      [FORM_TOGGLE_LOADING]: (state) => ({
        ...state,
        loading: !state.loading,
      }),
    },
    { show: false, data: null, loading: false }
  );

  return { list, form };
};

const projectReducers = createCrudReducers("PROJECT");
export const projects = projectReducers.list;
export const projectsForm = projectReducers.form;
